module.exports = {
  className: 'AppMenu',
  classNameLabel: 'App Menu',
  limit: 10,
  showExport: false,
  columns: [
    {
      columnName: 'objectId',
      type: 'string',
    },
    {
      columnName: 'name',
      type: 'string',
    },
    {
      columnName: 'label',
      type: 'string',
    },
    {
      columnName: 'url',
      type: 'string',
    },
    {
      columnName: 'browser',
      type: 'string',
    },
    {
      columnName: 'sort',
      type: 'number',
    },
    // {
    //     columnName: "position",
    //     type: "string"
    // },
    {
      columnName: 'createdAt',
      type: 'Date',
    },
    {
      columnName: 'updatedAt',
      type: 'Date',
    },
  ],
};



// WEBPACK FOOTER //
// ./components/AppMenu/AppMenuSchema.js